export default __webpack_public_path__ + "static/media/photo--sm--chris-4.d56c1b29.jpg";